// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cv50IKu_7xeldi7tTnBb {
  height: 400px;
  margin: -40px -40px 0;
}
@media only screen and (max-width: 1339px) {
  .cv50IKu_7xeldi7tTnBb {
    margin: -32px -24px 0;
  }
}
@media only screen and (max-width: 1259px) {
  .cv50IKu_7xeldi7tTnBb {
    height: 320px;
  }
}
@media only screen and (max-width: 767px) {
  .cv50IKu_7xeldi7tTnBb {
    height: 252px;
    margin: -24px -16px 0;
  }
}
.cv50IKu_7xeldi7tTnBb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.Z7gUqEi6xXx55yG3QMgn {
  max-width: 1200px;
  margin: -120px auto 0;
}
@media only screen and (max-width: 767px) {
  .Z7gUqEi6xXx55yG3QMgn {
    margin-top: -188px;
  }
}

.AHcn3MPkC283VhR8RCtR {
  display: flex;
  align-items: center;
  margin-bottom: 0px;
}
@media only screen and (max-width: 767px) {
  .AHcn3MPkC283VhR8RCtR {
    flex-wrap: wrap;
  }
}

.fvZbMYlfysP4ASCcyVSW {
  display: flex;
  margin-right: auto;
}
@media only screen and (max-width: 767px) {
  .fvZbMYlfysP4ASCcyVSW {
    width: 100%;
    margin: 0 0 16px;
  }
}

.rqG6dAeh3rzok1LfW8WW {
  padding: 8px 16px;
  border-radius: 8px;
  font-size: 15px;
  font-weight: 600;
  line-height: 1.6;
  color: #6F767E;
  transition: all 0.2s;
}
@media only screen and (max-width: 767px) {
  .rqG6dAeh3rzok1LfW8WW {
    flex-grow: 1;
  }
}
.rqG6dAeh3rzok1LfW8WW:hover, .rqG6dAeh3rzok1LfW8WW.oCHVuVN8VHNvoPPresTD {
  color: #1A1D1F;
}
.dark-mode .rqG6dAeh3rzok1LfW8WW:hover, .dark-mode .rqG6dAeh3rzok1LfW8WW.oCHVuVN8VHNvoPPresTD {
  color: #FCFCFC;
}

.rqG6dAeh3rzok1LfW8WW.oCHVuVN8VHNvoPPresTD {
  background: #EFEFEF;
}
.dark-mode .rqG6dAeh3rzok1LfW8WW.oCHVuVN8VHNvoPPresTD {
  background: #272B30;
}

.rqG6dAeh3rzok1LfW8WW:not(:last-child) {
  margin-right: 8px;
}
@media only screen and (max-width: 767px) {
  .rqG6dAeh3rzok1LfW8WW:not(:last-child) {
    margin-right: 0;
  }
}

@media only screen and (max-width: 767px) {
  .KYaGGVfpT5EplZB01L44 {
    flex-grow: 1;
  }
}

.BwW_bs7WyVKKJTfEsxzQ {
  margin-left: 16px;
}
@media only screen and (max-width: 767px) {
  .BwW_bs7WyVKKJTfEsxzQ {
    margin-left: 12px;
  }
}

.RCCL8kOldskJgtlGO09H {
  display: flex;
  flex-wrap: wrap;
  margin: -32px -12px 0;
}
@media only screen and (max-width: 639px) {
  .RCCL8kOldskJgtlGO09H {
    display: block;
    margin: 0;
  }
}

.s5hNaESkQMCMOzmdsNXO {
  flex: 0 0 calc(33.333% - 24px);
  width: calc(33.333% - 24px);
  margin: 32px 12px 0;
}
@media only screen and (max-width: 1023px) {
  .s5hNaESkQMCMOzmdsNXO {
    flex: 0 0 calc(50% - 24px);
    width: calc(50% - 24px);
  }
}
@media only screen and (max-width: 639px) {
  .s5hNaESkQMCMOzmdsNXO {
    width: 100%;
    margin: 24px 0 0;
  }
}

.No58OOm_XxZLhfhLyawP {
  margin-top: 40px;
  text-align: center;
}
@media only screen and (max-width: 1339px) {
  .No58OOm_XxZLhfhLyawP {
    margin-top: 32px;
  }
}
@media only screen and (max-width: 767px) {
  .No58OOm_XxZLhfhLyawP {
    margin-top: 24px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/ticket_delivery/details/details.module.sass","webpack://./src/styles/helpers.sass"],"names":[],"mappings":"AAEA;EACI,aAAA;EACA,qBAAA;AADJ;ACII;EDLJ;IAIQ,qBAAA;EACN;AACF;ACEI;EDRJ;IAMQ,aAAA;EAIN;AACF;ACGI;EDdJ;IAQQ,aAAA;IACA,qBAAA;EAON;AACF;AAPI;EACI,WAAA;EACA,YAAA;EACA,iBAAA;AASR;;AAPA;EACI,iBAAA;EACA,qBAAA;AAUJ;ACbI;EDCJ;IAIQ,kBAAA;EAYN;AACF;;AAXA;EACI,aAAA;EACA,mBAAA;EACA,kBAAA;AAcJ;ACxBI;EDOJ;IAKQ,eAAA;EAgBN;AACF;;AAfA;EACI,aAAA;EACA,kBAAA;AAkBJ;AClCI;EDcJ;IAIQ,WAAA;IACA,gBAAA;EAoBN;AACF;;AAnBA;EACI,iBAAA;EACA,kBAAA;ECuCA,eAAA;EACA,gBAAA;EACA,gBAAA;EDvCA,cCGC;EDFD,oBAAA;AAwBJ;AClDI;EDqBJ;IAOQ,YAAA;EA0BN;AACF;AA1BI;EAEI,cAAA;AA2BR;ACkHa;ED3ID,cCRP;ADoCL;;AA3BI;EACI,mBCRH;ADsCL;AC2Ga;EDvID,mBCPP;ADsCL;;AA9BI;EACI,iBAAA;AAiCR;ACxEI;EDsCA;IAGQ,eAAA;EAmCV;AACF;;AC7EI;ED2CJ;IAEQ,YAAA;EAqCN;AACF;;AApCA;EACI,iBAAA;AAuCJ;ACvFI;ED+CJ;IAGQ,iBAAA;EAyCN;AACF;;AAxCA;EACI,aAAA;EACA,eAAA;EACA,qBAAA;AA2CJ;AC/FI;EDiDJ;IAKQ,cAAA;IACA,SAAA;EA6CN;AACF;;AA5CA;EACI,8BAAA;EACA,2BAAA;EACA,mBAAA;AA+CJ;ACjHI;ED+DJ;IAKQ,0BAAA;IACA,uBAAA;EAiDN;AACF;ACjHI;EDyDJ;IAQQ,WAAA;IACA,gBAAA;EAoDN;AACF;;AAnDA;EACI,gBAAA;EACA,kBAAA;AAsDJ;ACxII;EDgFJ;IAIQ,gBAAA;EAwDN;AACF;ACpII;EDuEJ;IAMQ,gBAAA;EA2DN;AACF","sourcesContent":["@import ../../../styles/helpers\n\n.background\n    height: 400px\n    margin: -40px -40px 0\n    +x\n        margin: -32px -24px 0\n    +d\n        height: 320px\n    +m\n        height: 252px\n        margin: -24px -16px 0\n    img\n        width: 100%\n        height: 100%\n        object-fit: cover\n\n.card\n    max-width: 1200px\n    margin: -120px auto 0\n    +m\n        margin-top: -188px\n\n.control\n    display: flex\n    align-items: center\n    margin-bottom: 0px\n    +m\n        flex-wrap: wrap\n\n.nav\n    display: flex\n    margin-right: auto\n    +m\n        width: 100%\n        margin: 0 0 16px\n\n.link\n    padding: 8px 16px\n    border-radius: 8px\n    +base1-s\n    color: $n4\n    transition: all .2s\n    +m\n        flex-grow: 1\n    &:hover,\n    &.active\n        color: $n7\n        +dark\n            color: $n1\n    &.active\n        background: $n3\n        +dark\n            background: $n6\n    &:not(:last-child)\n        margin-right: 8px\n        +m\n            margin-right: 0\n\n.dropdownBox\n    +m\n        flex-grow: 1\n\n.filters\n    margin-left: 16px\n    +m\n        margin-left: 12px\n\n.products\n    display: flex\n    flex-wrap: wrap\n    margin: -32px -12px 0\n    +a\n        display: block\n        margin: 0\n\n.product\n    flex: 0 0 calc(33.333% - 24px)\n    width: calc(33.333% - 24px)\n    margin: 32px 12px 0\n    +t\n        flex: 0 0 calc(50% - 24px)\n        width: calc(50% - 24px)\n    +a\n        width: 100%\n        margin: 24px 0 0\n\n.foot\n    margin-top: 40px\n    text-align: center\n    +x\n        margin-top: 32px\n    +m\n        margin-top: 24px\n","@use \"sass:math\"\n\n// media queries\n=w\n    @media only screen and (max-width: \"1419px\")\n        @content\n=x\n    @media only screen and (max-width: \"1339px\")\n        @content\n=d\n    @media only screen and (max-width: \"1259px\")\n        @content\n=t\n    @media only screen and (max-width: \"1023px\")\n        @content\n=m\n    @media only screen and (max-width: \"767px\")\n        @content\n=a\n    @media only screen and (max-width: \"639px\")\n        @content\n=s\n    @media only screen and (max-width: \"474px\")\n        @content\n\n// fonts\n=inter\n    font-family: 'Inter', sans-serif\n\n// colors\n$p1: #2A85FF\n$p2: #83BF6E\n$p3: #FF6A55\n$p4: #8E59FF\n$s1: #FFBC99\n$s2: #CABDFF\n$s3: #B1E5FC\n$s4: #B5E4CA\n$s5: #FFD88D\n\n$n: #FFFFFF\n$n1: #FCFCFC\n$n2: #F4F4F4\n$n3: #EFEFEF\n$n4: #6F767E\n$n5: #33383F\n$n6: #272B30\n$n7: #1A1D1F\n$n8: #111315\n\n$shades1: #9A9FA5\n$shades2: #6F767E\n$shades3: rgba(#6F767E, .4)\n$shades4: rgba(#111315, .5)\n\n// typography\n=title1-s\n    font-size: 20px\n    font-weight: 600\n    line-height: math.div( 32 , 20 )\n    letter-spacing: -.02em\n    +m\n        font-size: 18px\n\n=title1-m\n    font-size: 20px\n    font-weight: 500\n    line-height: math.div(32,20)\n    letter-spacing: -.02em\n    +m\n        font-size: 18px\n\n=title2\n    font-size: 18px\n    line-height: math.div(24,18)\n    letter-spacing: -0.02em\n\n=base1-s\n    font-size: 15px\n    font-weight: 600\n    line-height: math.div(24,15)\n\n=base1-b\n    font-size: 15px\n    font-weight: 700\n    line-height: math.div(24,15)\n\n=base2\n    font-size: 14px\n    font-weight: 600\n    line-height: math.div(24,14)\n\n=body1-m\n    font-size: 15px\n    font-weight: 500\n    line-height: math.div(24,15)\n    letter-spacing: -.015em\n\n=body1-s\n    font-size: 15px\n    font-weight: 600\n    line-height: math.div(24,15)\n    letter-spacing: -.015em\n\n=body2-s\n    font-size: 14px\n    font-weight: 600\n    line-height: math.div(24,14)\n\n=caption1\n    font-size: 13px\n    font-weight: 600\n    line-height: math.div(16,13)\n\n=caption1-m\n    font-size: 13px\n    font-weight: 500\n    line-height: math.div(16,13)\n\n=caption2\n    font-size: 12px\n    font-weight: 700\n    line-height: math.div(16,12)\n\n=caption2-m\n    font-size: 12px\n    font-weight: 500\n    line-height: 1\n\n=button1\n    font-size: 15px\n    font-weight: 700\n    line-height: math.div(24,15)\n\n=button2\n    font-size: 13px\n    font-weight: 700\n    line-height: math.div(24,13)\n    \n//triangle\n=arr($width, $height, $bg, $direction)\n    width: 0px\n    height: 0px\n    border-style: solid\n    @if $direction == t\n        border-width: 0 $width / 2 + px $height + px $width / 2 + px\n        border-color: transparent transparent $bg transparent\n    @if $direction == r\n        border-width: $height / 2 + px 0 $height / 2 + px $width + px\n        border-color: transparent transparent transparent $bg\n    @if $direction == b\n        border-width: $height + px $width / 2 + px 0 $width / 2 + px\n        border-color: $bg transparent transparent transparent\n    @if $direction == l\n        border-width: $height / 2 + px $width + px $height / 2 + px 0\n        border-color: transparent $bg transparent transparent\n    @if $direction == tl\n        border-width: $height + px $width + px 0 0\n        border-color: $bg transparent transparent transparent\n    @if $direction == tr\n        border-width: 0 $width + px $height + px 0\n        border-color: transparent $bg transparent transparent\n    @if $direction == br\n        border-width: 0 0 $height + px $width + px\n        border-color: transparent transparent $bg transparent\n    @if $direction == bl\n        border-width: $width + px 0 0 $height + px\n        border-color: transparent transparent transparent $bg\n// example\n// +arr(500,50, #000, l)\n// +arr(500,50, #000, bl)\n\n// placeholder\n=placeholder\n    &::placeholder\n        @content\n\n// media query width\n=r($width)\n    @media only screen and (max-width: $width+ \"px\")\n        @content\n\n=rmin($width)\n    @media only screen and (min-width: $width+ \"px\")\n        @content\n\n// theme\n=dark\n    @at-root :global(.dark-mode) &\n        @content\n\n=dark-body\n    @at-root .dark-mode\n        @content\n\n=dark-common\n    @at-root .dark-mode &\n        @content"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"background": `cv50IKu_7xeldi7tTnBb`,
	"card": `Z7gUqEi6xXx55yG3QMgn`,
	"control": `AHcn3MPkC283VhR8RCtR`,
	"nav": `fvZbMYlfysP4ASCcyVSW`,
	"link": `rqG6dAeh3rzok1LfW8WW`,
	"active": `oCHVuVN8VHNvoPPresTD`,
	"dropdownBox": `KYaGGVfpT5EplZB01L44`,
	"filters": `BwW_bs7WyVKKJTfEsxzQ`,
	"products": `RCCL8kOldskJgtlGO09H`,
	"product": `s5hNaESkQMCMOzmdsNXO`,
	"foot": `No58OOm_XxZLhfhLyawP`
};
export default ___CSS_LOADER_EXPORT___;
